function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from 'mkui-fd';

var CollapseButton = /*#__PURE__*/function (_React$Component) {
  _inherits(CollapseButton, _React$Component);

  function CollapseButton(props) {
    var _this;

    _classCallCheck(this, CollapseButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CollapseButton).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var collapse = _this.state.collapse;
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        collapse: !collapse
      });

      var onClick = _this.props.onClick;

      if (onClick) {
        onClick(collapse);
      }
    });

    _this.state = {
      collapse: typeof props.collapse === 'undefined' ? false : props.collapse
    };
    return _this;
  }

  _createClass(CollapseButton, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          children = _this$props.children;
      var collapse = this.state.collapse;
      var classString = classNames(prefixCls, _defineProperty({}, "".concat(prefixCls, "-expanse"), collapse));
      return React.createElement("a", {
        onClick: function onClick(e) {
          return _this2.handleClick(e);
        },
        className: classString
      }, React.createElement("span", null, children), React.createElement(Icon, {
        type: "angle-double-right"
      }));
    }
  }]);

  return CollapseButton;
}(React.Component);

_defineProperty(CollapseButton, "defaultProps", {
  prefixCls: 'mkui-collapse-btn',
  collapse: true
});

_defineProperty(CollapseButton, "propTypes", {
  collapse: PropTypes.bool,
  prefixCls: PropTypes.string
});

export { CollapseButton as default };
//# sourceMappingURL=CollapseButton.js.map
